import type { ReactNode } from "react";
import { Link } from "react-router";

import type { FbsFinding } from "@/lib/providers";

/**
 * Находка контроля FBS: описание словами плюс АДРЕСА для разбора.
 *
 * Ссылки — требование владельца 09.09.26: из находки должен открываться
 * разбор вещи, а не только её описание. Серия ведёт в карточку вещи, задачи —
 * в карточки задач, где видны поставка и статус у площадки.
 *
 * Формы находки экран не знает и знать не должен: дверь присылает готовые
 * строки, а сюда едут только адреса. Поэтому новое правило контроля
 * добавляется строкой в реестре на сервере и появляется здесь само.
 *
 * Компонент ОДИН на два экрана — раздел «FBS Контроль» и карточку баркода:
 * находка обязана читаться одинаково независимо от того, пришли к ней от
 * склада целиком или от ярлыка в руке.
 *
 * Метки «разобрать» здесь нет: разбора требует КАЖДАЯ показанная находка, и
 * значок на всех строках подряд перестал бы что-либо означать. Законные
 * случаи (отменённая задача рядом с живой) до экрана не доходят вовсе.
 *
 * `children` — действие над находкой («Разобрано», «Вернуть»). Его даёт
 * раздел контроля; карточка баркода находку только показывает.
 */
export function FindingRow({
  item,
  children,
}: {
  item: FbsFinding;
  children?: ReactNode;
}) {
  return (
    <li
      data-annot={item.serial ? `находка ${item.serial}` : "находка"}
      className="px-3 py-2"
    >
      <div className="flex flex-wrap items-center gap-2">
        {item.serial ? (
          <Link
            to={`/serial/${item.serial}`}
            className="font-mono text-[12.5px] text-accent-text hover:underline"
          >
            серия {item.serial}
          </Link>
        ) : null}
        {item.tasks.map((id) => (
          <Link
            key={id}
            to={`/fbs-task/${id}`}
            className="rounded-[var(--radius-ui)] border border-border px-2 py-0.5 text-[11.5px] text-fg-muted hover:bg-bg-hover hover:text-fg"
          >
            задача {id}
          </Link>
        ))}
      </div>
      <div className="mt-1 flex flex-col gap-0.5">
        {item.lines.map((line, i) => (
          <p key={i} className={i === 0 ? "text-[12.5px]" : "text-[12px] text-fg-muted"}>
            {line}
          </p>
        ))}
      </div>
      {children}
    </li>
  );
}
